const packageJson = require('../package.json');

export const VERSION = packageJson.version;
